import { LazyImageActionType } from './types';

export const lazyImageAction = (type: string, payload: boolean): LazyImageActionType => ({
    type,
    payload,
});
export default { lazyImageAction };
